module.exports = __webpack_public_path__ + "img/og.2bb61c0a.jpg";